import moment from '../../../utils/momentBusinessDays';
import {
  ActionType,
  AutoTextField,
  FormField,
} from '../../../components/AutoForm/AutoFieldNew';
import {OVRecommendActionEnum, AdhocFeeTypeEnum} from '../../../schema-types/globalTypes';
import {
  getBusinessDatesDifference,
  getLastThursdayOfMonth,
} from '../../../utils/getLastWeekdayOfMonth';
import {adHocFeeFieldType} from './builderAdHocFeeFields';
import {contributeFrequencyComboField as frequencyComboField} from '../BuilderContribute/builderContributeFields';
import FREQUENCY from '../../../constants/Frequency';

export const amountAdHocField: FormField = {
  id: 'adHocFee.monetaryFee',
  label: 'Ad-hoc Fee Amount',
  type: ActionType.text,
  initialValue: undefined,
  currency: true,
};
export const percentAdHocField: FormField = {
  id: 'adHocFee.percentFee',
  label: 'Ad-hoc Fee Amount',
  type: ActionType.text,
  initialValue: undefined,
  percent: true,
  decimals: 2,
};
export const reasonAdHocField: AutoTextField = {
  id: 'adHocFee.reason',
  label: 'Fee Justification',
  type: ActionType.text,
  initialValue: undefined,
  charLimit: 500,
  multiline: true,
  minRows: 3,
};
export const frequencyAdHocField: FormField = {
  ...frequencyComboField,
  id: 'adHocFee.frequency',
};
export const crystallisedAdHocField: FormField = {
  id: 'adHocFee.crystallised',
  label: 'Crystallised',
  type: ActionType.text,
  initialValue: undefined,
  currency: true,
  disabled: true,
  readOnly: true,
};
export const uncrystallisedAdHocField: FormField = {
  id: 'adHocFee.uncrystallised',
  label: 'Un-Crystallised',
  type: ActionType.text,
  initialValue: undefined,
  currency: true,
  disabled: true,
  readOnly: true,
};
export const instructionDateAdHocField: FormField = {
  id: 'adHocFee.instructionDate',
  label: 'Instruction Date',
  type: ActionType.datepicker,
  initialValue: undefined,
  shouldDisableDate(date) {
    const lastThursday = getLastThursdayOfMonth(date);
    const diff = getBusinessDatesDifference(
      moment.utc(new Date()),
      moment.utc(lastThursday)
    );
    /**
     * To allow our internal teams to process the charge efficiently,
     * this date cannot be selected if it is less than 6 business days away.
     */
    if (diff < 6) {
      return true;
    }
    if (lastThursday.toISOString() === date.toISOString()) {
      return false;
    }
    return true;
  },
};
export const feeTypeAdHocField: FormField = {
  type: ActionType.select,
  id: 'adHocFee.feeType',
  fullWidth: true,
  label: 'Ad-Hoc Fee Type',
  options: [
    {
      label: '£',
      value: AdhocFeeTypeEnum.GBP,
    },
    {
      label: '%',
      value: AdhocFeeTypeEnum.PERCENT,
    },
  ],
};

/**
 * Crystallised and uncrystallised will come pre-populated
 * from the back-end and are non-editable
 */
export const initialAdHocFee: adHocFeeFieldType = {
  monetaryFee: 0,
  percentFee: 0,
  feeType: AdhocFeeTypeEnum.GBP,
  reason: undefined,
  planId: '',
  crystallised: 0,
  uncrystallised: 0,
  frequency: FREQUENCY.SINGLE,
  // instructionDate: null,
};
